// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor3 from '@/game/prefabs/World/Mentors/Mentor3';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level11 extends TilemapScene {
  constructor() {
    super('Level11');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // desert_biome_1
    const desert_biome_1 = this.add.tilemap('desert-biome-1');
    desert_biome_1.addTilesetImage('desert sands v01', 'desert sands v01');
    desert_biome_1.addTilesetImage(
      'desert sands prefabs',
      'desert sands prefabs',
    );
    desert_biome_1.addTilesetImage('collision', 'collision & alpha');

    // terrain_1
    desert_biome_1.createLayer(
      'terrain',
      ['desert sands v01', 'desert sands prefabs'],
      0,
      0,
    );

    // deco
    desert_biome_1.createLayer('deco 1', ['desert sands v01'], 0, 0);

    // cOLLISION_1
    const cOLLISION_1 = desert_biome_1.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      384,
      400,
      'desert cactuses 32x',
      0,
    );
    this.add.existing(forestTree1);
    forestTree1.scaleX = -1;
    forestTree1.scaleY = 1;

    // forestTree
    const forestTree = new ForestTree1(
      this,
      720,
      128,
      'desert cactuses 32x',
      0,
    );
    this.add.existing(forestTree);
    forestTree.scaleX = -1;
    forestTree.scaleY = 1;

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      624,
      448,
      'desert cactuses 32x',
      0,
    );
    this.add.existing(forestTree_1);
    forestTree_1.scaleX = 1;
    forestTree_1.scaleY = 1;

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      224,
      112,
      'desert cactuses 32x',
      0,
    );
    this.add.existing(forestTree_2);
    forestTree_2.scaleX = 1;
    forestTree_2.scaleY = 1;

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      80,
      368,
      'desert cactuses 32x',
      1,
    );
    this.add.existing(forestTree_3);
    forestTree_3.scaleX = -1;
    forestTree_3.scaleY = 1;

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      768,
      512,
      'desert cactuses 32x',
      1,
    );
    this.add.existing(forestTree_4);
    forestTree_4.scaleX = 1;
    forestTree_4.scaleY = 1;

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      512,
      352,
      'desert cactuses 32x',
      1,
    );
    this.add.existing(forestTree_5);
    forestTree_5.scaleX = 1;
    forestTree_5.scaleY = 1;

    // forestTree_6
    const forestTree_6 = new ForestTree1(this, 760, 160, 'desert 16x_1', 2);
    this.add.existing(forestTree_6);
    forestTree_6.scaleX = 1;
    forestTree_6.scaleY = 1;

    // forestTree_7
    const forestTree_7 = new ForestTree1(this, 664, 80, 'desert 16x_1', 2);
    this.add.existing(forestTree_7);
    forestTree_7.scaleX = 1;
    forestTree_7.scaleY = 1;

    // forestTree_8
    const forestTree_8 = new ForestTree1(this, 24, 272, 'desert 16x_1', 2);
    this.add.existing(forestTree_8);
    forestTree_8.scaleX = 1;
    forestTree_8.scaleY = 1;

    // forestTree_9
    const forestTree_9 = new ForestTree1(this, 280, 224, 'desert 16x', 2);
    this.add.existing(forestTree_9);
    forestTree_9.scaleX = 1;
    forestTree_9.scaleY = 1;

    // forestTree_10
    const forestTree_10 = new ForestTree1(this, 136, 96, 'desert 16x', 2);
    this.add.existing(forestTree_10);
    forestTree_10.scaleX = 1;
    forestTree_10.scaleY = 1;

    // forestTree_11
    const forestTree_11 = new ForestTree1(this, 456, 80, 'desert 16x', 2);
    this.add.existing(forestTree_11);
    forestTree_11.scaleX = 1;
    forestTree_11.scaleY = 1;

    // forestTree_12
    const forestTree_12 = new ForestTree1(this, 456, 224, 'desert 16x', 2);
    this.add.existing(forestTree_12);
    forestTree_12.scaleX = 1;
    forestTree_12.scaleY = 1;

    // forestTree_13
    const forestTree_13 = new ForestTree1(this, 616, 144, 'desert 16x', 2);
    this.add.existing(forestTree_13);
    forestTree_13.scaleX = 1;
    forestTree_13.scaleY = 1;

    // forestTree_14
    const forestTree_14 = new ForestTree1(this, 584, 272, 'desert 16x', 2);
    this.add.existing(forestTree_14);
    forestTree_14.scaleX = 1;
    forestTree_14.scaleY = 1;

    // forestTree_15
    const forestTree_15 = new ForestTree1(this, 712, 496, 'desert 16x', 2);
    this.add.existing(forestTree_15);
    forestTree_15.scaleX = 1;
    forestTree_15.scaleY = 1;

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      336,
      112,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_16);
    forestTree_16.scaleX = 1;
    forestTree_16.scaleY = 1;

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      432,
      176,
      'desert cactuses 32x',
      2,
    );
    this.add.existing(forestTree_17);
    forestTree_17.scaleX = 1;
    forestTree_17.scaleY = 1;

    // forestTree_18
    const forestTree_18 = new ForestTree1(this, 376, 224, 'desert 16x_1', 0);
    this.add.existing(forestTree_18);
    forestTree_18.scaleX = 1;
    forestTree_18.scaleY = 1;

    // forestTree_19
    const forestTree_19 = new ForestTree1(this, 344, 176, 'desert 16x_1', 0);
    this.add.existing(forestTree_19);
    forestTree_19.scaleX = 1;
    forestTree_19.scaleY = 1;

    // forestTree_20
    const forestTree_20 = new ForestTree1(this, 296, 128, 'desert 16x_1', 0);
    this.add.existing(forestTree_20);
    forestTree_20.scaleX = 1;
    forestTree_20.scaleY = 1;

    // forestTree_21
    const forestTree_21 = new ForestTree1(this, 312, 144, 'desert 16x_1', 0);
    this.add.existing(forestTree_21);
    forestTree_21.scaleX = 1;
    forestTree_21.scaleY = 1;

    // forestTree_22
    const forestTree_22 = new ForestTree1(this, 488, 128, 'desert 16x_1', 0);
    this.add.existing(forestTree_22);
    forestTree_22.scaleX = 1;
    forestTree_22.scaleY = 1;

    // forestTree_23
    const forestTree_23 = new ForestTree1(this, 376, 80, 'desert 16x_1', 0);
    this.add.existing(forestTree_23);
    forestTree_23.scaleX = 1;
    forestTree_23.scaleY = 1;

    // forestTree_24
    const forestTree_24 = new ForestTree1(this, 360, 96, 'desert 16x_1', 0);
    this.add.existing(forestTree_24);
    forestTree_24.scaleX = 1;
    forestTree_24.scaleY = 1;

    // forestTree_25
    const forestTree_25 = new ForestTree1(this, 296, 64, 'desert 16x_1', 0);
    this.add.existing(forestTree_25);
    forestTree_25.scaleX = 1;
    forestTree_25.scaleY = 1;

    // player
    const player = new Player(this, 40, 96);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 64, 192);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 120, 424);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 416, 56);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 696, 176);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 432, 280);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 728, 336);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 760, 408);
    this.add.existing(portal);

    // mentor
    const mentor = new Mentor3(this, 88, 56);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 696, 448);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 280, 440);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 376, 160);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 600, 216);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 10;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 10;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 10;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 10;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 10;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 10;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 10;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 10;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 10;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 10;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.desert_biome_1 = desert_biome_1;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor3;
  private desert_biome_1!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.desert_biome_1,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
